<template>
  <div>
    <ComboboxSeparator class="border-secondary border-t" />
    <div class="mx-3 my-2 gap-2 flex">
      <ButtonGroup class="w-full">
        <ButtonGroupItem
          :label="t(`components.sorting.${sortingValues.sort_by}.asc`)"
          :active="isActive('asc')"
          @click="handleOrder('asc')"
          class="w-1/2 !px-1"
          size="md"
        />
        <ButtonGroupItem
          :label="t(`components.sorting.${sortingValues.sort_by}.desc`)"
          :active="isActive('desc')"
          @click="handleOrder('desc')"
          class="w-1/2"
          size="md"
        />
      </ButtonGroup>
    </div>
  </div>
</template>

<script setup>
import { ButtonGroup, ButtonGroupItem } from "@/SharedComponents/ButtonGroup";
import { ComboboxSeparator } from "radix-vue";
import { useI18n } from "vue-i18n";

import { storeToRefs } from "pinia";
import { useSorting } from "@/Composables/useSorting.js";

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
});

const sortingStore = useSorting(props.type);
const { sortingValues } = storeToRefs(sortingStore);
const { handleSortingChange } = sortingStore;

const { t } = useI18n();

const isActive = (order) => {
  return sortingValues.value.order_by === order;
};

const handleOrder = (value) => {
  handleSortingChange({
    id: sortingValues.value.sort_by,
    desc: value === "desc" ? true : false,
  });
};
</script>
